import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="px-4 md:px-6 py-14 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">亲亲漫画</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              免费韩漫、日漫、国漫在线阅读平台，支持手机APP下载。海量热门漫画每日更新，下拉式阅读更流畅。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-all duration-200">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-all duration-200">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-all duration-200">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">首页</Link>
              </li>
              <li>
                <Link to="/category/hanman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">韩漫专区</Link>
              </li>
              <li>
                <Link to="/category/riman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">日漫专区</Link>
              </li>
              <li>
                <Link to="/category/guoman" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">国漫专区</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-sm text-foreground-500"></i>
                </div>
                <span className="text-sm text-foreground-400">contact@qinqinmanga.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-customer-service-line text-sm text-foreground-500"></i>
                </div>
                <span className="text-sm text-foreground-400">QQ群：874123569</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-smartphone-line text-sm text-foreground-500"></i>
                </div>
                <span className="text-sm text-foreground-400">APP下载请点击上方按钮</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 亲亲漫画 QinQinManga. All Rights Reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}